import { Component, OnInit, ViewChild } from '@angular/core';
import { TitlebarComponent } from '../shared/titlebar/titlebar.component';

import { NotificationService, LoaderService } from "../shared/session/index"
import { AplicacionService } from './security/Aplicaciones/shared/aplicacion.service';
import { Iapplication } from './security/Aplicaciones/shared/aplicacion.model';
import { SessionInfo } from '../shared/session/SessionInfo';

@Component({
  // moduleId: module.id,
  selector: 'app-landing',
  templateUrl: 'landing-aplicacion.component.html'
})
export class LandingComponent implements OnInit {
  aplicaciones: Iapplication[];
  msgErrorGet: string;
  @ViewChild(TitlebarComponent) titlebarComponent: TitlebarComponent;

  constructor(private loaderService: LoaderService,
    private aplicacionService: AplicacionService,
    private sessionInfo: SessionInfo,
    private notificationService: NotificationService) { }

  ngOnInit() {
    this.titlebarComponent.msgTitle = [{ title: "Lista de Aplicaciones", event: "" }];
    let body = document.getElementsByTagName('body')[0];
    body.classList.add("bodyLanding");
    this.msgErrorGet = 'Error al listar Aplicaciones';
    this.listarAplicaciones();
  }

  listarAplicaciones(): void {
    this.loaderService.show();
    this.aplicacionService.listarAplicacionPorAcceso(this.sessionInfo.getIdUsuario(), this.sessionInfo.getIdNivelAcceso(), this.sessionInfo.getIdEntidad(), this.sessionInfo.getRoleID())
      .subscribe(res => {
        this.aplicaciones = res;
      },
        error => {
          this.notificationService.error(this.msgErrorGet);
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }

  public goToUrl(path: string): void {
    window.open(path, "_blank");
  }
}
